import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';

import {environment} from './environments/environment';

if (environment.production) {
  console.log = () => {};
  enableProdMode();
}

if (window.location.href.indexOf('localhost') === -1) {
  /*  Sentry.init({
    dsn: 'https://2f27441759f24945a6b089a571c531f9@o465887.ingest.sentry.io/5594535',
    integrations: [
      // Registers and configures the Tracing integration,
      // which automatically instruments your application to monitor its
      // performance, including custom Angular routing instrumentation
      new Integrations.BrowserTracing({

        tracingOrigins: ['localhost', environment.host + '/mpds-crud-service'],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });*/
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
